import { render } from "./PayIconComponent.vue?vue&type=template&id=33133238"
import script from "./PayIconComponent.vue?vue&type=script&lang=js"
export * from "./PayIconComponent.vue?vue&type=script&lang=js"

import exportComponent from "/home/user/devops/sourcecode/Sopecam/sopecam-cameroontribune-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__